import { createSelector } from 'reselect';

const getVideosState = state => state.videos;

// eslint-disable-next-line import/prefer-default-export
export const getVideos = createSelector(
    getVideosState,
    videos => videos.data,
);
